module.exports = __webpack_public_path__ + "static/media/EXTINTORES.3a73d442.jpg";